module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formset__header",
    class: {
      'formset__header--errors': this.errors
    }
  }, [_c('span', [(_vm.errors) ? _c('i', {
    staticClass: "fa fa-warning"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "formset__header__buttons"
  }, [(_vm.index !== _vm.items.length - 1) ? _c('el-button', {
    attrs: {
      "size": "small",
      "title": "Przesuń w dół"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder(_vm.items, _vm.index, 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    style: ({
      opacity: _vm.index !== 0 ? 1 : 0
    }),
    attrs: {
      "size": "small",
      "title": "Przesuń do góry"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeOrder(_vm.items, _vm.index, -1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "title": "Usuń element"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeItemFromFormset(_vm.items, _vm.item)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3c5981"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormsetHeader.vue
// module id = 718
// module chunks = 0